import * as Utils from './utils';

const navTriggers = document.querySelectorAll('.js-nav-trigger'),
    searchIcon = document.querySelectorAll('.js-search-function'),
    areaTabTriggers = document.querySelectorAll('.js-nav-area-tab-trigger'),
    areaTabContent = document.querySelectorAll('.js-nav-area-tab-content');

let winScrollThrottle;

function toggleNavigationPane(e) {
    e.preventDefault();

    const body = document.querySelector('body');

    body.classList.remove('restrict-height');

    body.classList.toggle('nav-open');

    if (body.classList.contains('nav-open')) {
        setTimeout(() => {
            body.classList.add('restrict-height');
        }, 200);
    }
}

function doSearchFunction(e) {
    const input = e.target.parentElement.querySelector('.js-search-input');

    // If search field is empty, stop form
    if (input.value.length == 0 || input.value == 'Search...') {
        e.preventDefault();
        return;
    }
}

export function checkScrollPosition() {
    let fill = Utils.getScrollTop() > 0 ? true : false;
    headerFillTransparency(fill);
}

function headerFillTransparency(fill) {
    const header = document.querySelector('.header'),
        navTriggerContainer = document.querySelector('.js-burger-container');

    header.classList[fill == true ? 'add' : 'remove']('scroll');
    navTriggerContainer.classList[fill == true ? 'add' : 'remove']('scroll');
}

function changeNavTab(e, profile) {
    e.preventDefault();

    let clickedTrigger = false;

    // Change .active tab nav item
    areaTabTriggers.forEach(el => {
        clickedTrigger = el === e.target ? el : e.target.closest('.js-nav-area-tab-trigger');

        // Find currently active item and remove class
        if (el === clickedTrigger) {
            clickedTrigger.classList.add('active');
        } else {
            el.classList.remove('active');
        }
    });

    // Could determine which trigger/button was clicked on so bail out
    if (!clickedTrigger) {
        return false;
    }

    // Change .active tab
    areaTabContent.forEach(el => {
        if ('tab' in el.dataset && el.dataset.tab === clickedTrigger.dataset.target) {
            el.classList.add('active');

            // Autofocus the search input if the search tab is now active
            if (el.dataset.tab === 'nav-tab-search') {
                const input = el.querySelector('.js-search-input');

                if (input) {
                    input.focus();
                }
            }
        } else {
            el.classList.remove('active');
        }
    });
}

areaTabTriggers.forEach(el => {
    el.addEventListener('click', e => {
        changeNavTab(e, el);
    });
});

searchIcon.forEach(el => {
    el.addEventListener('click', doSearchFunction);
});

navTriggers.forEach(el => {
    el.addEventListener('click', toggleNavigationPane);
});

window.addEventListener('scroll', () => {
    checkScrollPosition();
});

checkScrollPosition();
